import React from "react";
import { Container } from "react-bootstrap";
import HGSNavbar from "./components/HGSNavbar";
import HGSServices from "./components/HGSServices";
import HGSContact from "./components/HGSContact";

const App = () => {
  return (
    <Container fluid={true} className="m-0 p-0">
      <HGSNavbar />
      <Container className="mt-3">
        <h4>Our Services & Price</h4>
        <hr />
        <HGSServices />
      </Container>
      <Container className="mt-3">
        <h4>Contact</h4>
        <hr />
        <HGSContact />
      </Container>
    </Container>
  );
};

export default App;
